import { HttpErrorResponse } from '@angular/common/http';

export class ReauthError extends Error {
    constructor(public originalError: HttpErrorResponse) {
        super('Reauthentication required');
        this.name = 'ReauthError';
    }
}
